// 默认舞台内边距
export const DEFAULT_STAGE_PADDING = 35;
// 最小宽
export const MIN_STAGE_WIDTH = 20;
// 最大宽
export const MAX_STAGE_WIDTH = 8000;
// 最小高
export const MIN_STAGE_HEIGHT = 20;
// 最大高
export const MAX_STAGE_HEIGHT = 8000;

// 最大宽 cm/mm 统一按cm来
export const MAX_STAGE_WIDTH_CM = 200;

// 最大高 cm/mm 统一按cm来
export const MAX_STAGE_HEIGHT_CM = 200;

// 默认300分辨率，当通过cm/mm 设置超过67.7时通过降低分辨率来实现 像素不变，cm增加
export const CHANGE_DPI_WIDTH_EDGE = 67.7;

export const CHANGE_DPI_HEIGHT_EDGE = 67.7;

// 低于该值会对操作按钮做隐藏处理
export const HIDDEN_OPERATE_MIN_WIDTH = 25;
export const HIDDEN_OPERATE_MIN_HEIGHT = 25;
